const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://clif.ai" // Production URL
    : "https://uat.clif.ai:5001"; // UAT URL (for development or testing
export default API_URL;

